import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import '../Turnero.css';

/**
 * StaffLogin - Dedicated login for Turnero Staff
 */
const StaffLogin = ({ ipserv, onLoginSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        dni: '',
        password: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        request.Post(ipserv + 'staffLogin', formData, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Bienvenido ' + r.user.UsrNombre });
                // We pass the user object which contains SucursalId and TipoAsociado
                onLoginSuccess(r.user);
            } else {
                Notify({ type: 'fail', text: r.message || 'Credenciales inválidas' });
            }
            setLoading(false);
        });
    };

    return (
        <div className="turnero-container d-flex align-items-center justify-content-center p-3 text-center">
            <div className="turnero-card p-5 animate-in" style={{ maxWidth: '450px', width: '100%' }}>
                <h1 className="turnero-title mb-1">Turnero</h1>
                <p className="text-muted mb-4 small">MÓDULO DE ATENCIÓN</p>

                <form onSubmit={handleSubmit} className="text-left">
                    <div className="mb-3">
                        <label className="small text-muted mb-1">DNI</label>
                        <input
                            type="text"
                            className="turnero-input"
                            value={formData.dni}
                            onChange={e => setFormData({ ...formData, dni: e.target.value })}
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="small text-muted mb-1">Contraseña</label>
                        <input
                            type="password"
                            className="turnero-input"
                            value={formData.password}
                            onChange={e => setFormData({ ...formData, password: e.target.value })}
                            required
                        />
                    </div>

                    <button type="submit" className="turnero-btn turnero-btn-primary w-100 py-3" disabled={loading}>
                        {loading ? <Spinner animation="border" size="sm" /> : 'Entrar al Sistema'}
                    </button>

                    <div className="mt-4 text-center">
                        <small className="text-muted">&copy; 2026 OctoCore Systems</small>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default StaffLogin;
